import axios, { AxiosInstance } from "axios";
import { API_URL, Constants } from "./constants";
import { AuthService } from "./AuthService";
let accessToken = window.localStorage.getItem("accessToken")

let isRefreshing = false;
let cancelSource = axios.CancelToken.source();

const http = axios.create({
  baseURL: API_URL.INTEGRATION_API_URL,
  headers: {
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

const httpAuth = axios.create({
  baseURL: API_URL.AUTH_API_URL,
  headers: {
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

const httpEmployee = axios.create({
  baseURL: API_URL.EMPLOYEE_API_URL,
  headers: {
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

const httpCore = axios.create({
  baseURL: API_URL.CORE_API_URL,
  headers: {
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

const httpBlobGetServiceApiRoot = axios.create({
  baseURL: Constants.blobServiceApiRoot,
  headers: {
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

// http.interceptors.request.use(
//   async (config) => {
//     config.headers.Authorization = `Bearer ${accessToken}`;
//     config.cancelToken = cancelSource.token;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// httpEmployee.interceptors.request.use(
//   async (config) => {
//     config.headers.Authorization = `Bearer ${accessToken}`;
//     config.cancelToken = cancelSource.token;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// httpAuth.interceptors.request.use(
//   async (config) => {
//     const authService = new AuthService();
//     config.headers.Authorization = `Bearer ${accessToken}`;
//     config.cancelToken = cancelSource.token;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// httpCore.interceptors.request.use(
//   async (config) => {
//     const authService = new AuthService();
//     config.headers.Authorization = `Bearer ${accessToken}`;
//     config.cancelToken = cancelSource.token;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// httpBlobGetServiceApiRoot.interceptors.request.use(
//   async (config) => {
//     const authService = new AuthService();
//     config.headers.Authorization = `Bearer ${accessToken}`;
//     config.cancelToken = cancelSource.token;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// Add a response interceptor to handle token refresh and retry failed requests
function setupResponseInterceptor(instance : AxiosInstance) {
  instance.interceptors.request.use(
    async (config) => {
      config.headers.Authorization = `Bearer ${window.localStorage.getItem("accessToken")}`;
      config.cancelToken = cancelSource.token;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (error) => {
      const originalRequest = error.config;
  
      if (error.response?.status === 401 && cancelSource.token == originalRequest.cancelToken) {
        originalRequest._retry = true;
  
        if (!isRefreshing) {
          isRefreshing = true;
          cancelSource.cancel("Token expired. Cancelling all requests.");
          cancelSource = axios.CancelToken.source();
  
          try {
            const authService = new AuthService();
            authService.login(); // redirect to login

          } catch (err) {
            return Promise.reject(err);
          } finally {
            isRefreshing = false;
          }
        }
  
        return new Promise(() => {}); // keep other 401 calls waiting silently
      }
  
      return Promise.reject(error);
    }
  );
}

setupResponseInterceptor(http);
setupResponseInterceptor(httpAuth);
setupResponseInterceptor(httpEmployee);
setupResponseInterceptor(httpCore);
setupResponseInterceptor(httpBlobGetServiceApiRoot);

export { http, httpAuth, httpEmployee, httpBlobGetServiceApiRoot, httpCore };
